import { onClickOutside } from '@vueuse/core';

function initAdaptiveShareBlockComponent(app) {
    app.component('adaptive-share-block', {
        template: '#adaptive-share-block',
        data() {
            return {
                shareBannerState: ShareBannerState.DEFAULT,
                ShareBannerState,
                copyLink: '',
                mainShareSocials: [],
                secondaryShareSocials: [],
            };
        },
        props: {
            shareSocials: {
                type: String,
                required: true,
            },
            absoluteShareUrl: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                default: '',
            },
        },
        computed: {
            encodedUrl() {
                return encodeURIComponent(this.absoluteShareUrl);
            },
            encodedTitle() {
                return encodeURIComponent(this.title);
            },
            shareUrls() {
                const socials = this.getShareSocialsData();
                return {
                    vkontakte: `https://vk.com/share.php?url=${this.encodedUrl}&title=${this.encodedTitle}&${socials.vkontakte.shareParam}`,
                    odnoklassniki: `https://connect.ok.ru/offer?url=${this.encodedUrl}&title=${this.encodedTitle}&${socials.odnoklassniki.shareParam}`,
                    twitter: `https://twitter.com/intent/tweet?url=${this.encodedUrl}&text=${this.encodedTitle}&${socials.twitter.shareParam}`,
                    facebook: `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}&${socials.facebook.shareParam}`,
                };
            },
        },
        methods: {
            async copy() {
                this.shareBannerState = ShareBannerState.COPIED;
                await this.$nextTick(async () => { await this.copyToClipboardAsync(); });
            },

            async copyToClipboardAsync() {
                if (this.$refs.copyInput) {
                    await navigator.clipboard.writeText(this.$refs.copyInput.value);

                    this.$refs.copyInput.select();
                    this.$refs.copyInput.scrollIntoView({ behavior: "smooth" });
                    this.$refs.copyInput.focus({ preventScroll: true });
                    this.$refs.copyInput.scrollLeft = 0;
                }
            },

            share() {
                this.shareBannerState = ShareBannerState.SHARED;
                this.$nextTick(this.scrollToShareBlock);
            },

            scrollToShareBlock() {
                if (this.$refs.shareBlock) {
                    this.$refs.shareBlock.scrollIntoView();
                }
            },

            clickOutside() {
                if (this.$refs.dropdown) {
                    this.$refs.dropdown.close();
                }
            },

            getFullUrl(shareTypeLinkPart) {
                return `${this.absoluteShareUrl}&${shareTypeLinkPart}`;
            },

            _initiateShares() {
                const sharesData = this.getShareSocialsData();
                const shareSocialsArray = JSON.parse(this.shareSocials);
                const mappedShares = shareSocialsArray.map((socialName) => ({
                    ...sharesData[socialName],
                    shareUrl: this.shareUrls[socialName],
                }));

                this.splitShareButtons(mappedShares);
                this.copyLink = this.getFullUrl('src=lnk');

                this.$nextTick(() => {
                    if (this.$refs.dropdown) {
                        onClickOutside(this.$refs.dropdown, this.clickOutside);
                    }
                });
            },

            getShareSocialsData() {
                return {
                    vkontakte: {
                        label: 'vk',
                        logo: 'fab fa-vk',
                        shareParam: 'src=vk',
                    },
                    odnoklassniki: {
                        label: 'odnoklassniki',
                        logo: 'fab fa-odnoklassniki',
                        shareParam: 'src=ok',
                    },
                    twitter: {
                        label: 'twitter',
                        logo: 'fab fa-twitter',
                        shareParam: 'src=tw',
                    },
                    facebook: {
                        label: 'facebook',
                        logo: 'fab fa-facebook-f',
                        shareParam: 'src=fb',
                    },
                };
            },

            splitShareButtons(mappedShares) {
                const isMobileScreen = window.matchMedia('(max-width: 560px)').matches;

                const mobileMainButtonsLimit = 3;
                const desktopMainButtonsLimit = 4;
                const buttonsLimit = isMobileScreen ? mobileMainButtonsLimit : desktopMainButtonsLimit;

                if (mappedShares.length > buttonsLimit) {
                    this.mainShareSocials = mappedShares.slice(0, buttonsLimit - 1);
                    this.secondaryShareSocials = mappedShares.slice(buttonsLimit - 1);
                } else {
                    this.mainShareSocials = mappedShares;
                    this.secondaryShareSocials = [];
                }
            },
        },
        mounted() {
            this._initiateShares();
        },
    });
}

const ShareBannerState = Object.freeze({
    COPIED: 'copied',
    SHARED: 'shared',
    DEFAULT: 'default',
});

export default initAdaptiveShareBlockComponent;